import { IconArrowRight, ProfileImage } from '@leland-dev/leland-ui-library';
import Link from 'next/link';
import { type FC } from 'react';

import { getCoachProfileUrl } from '../../../../utils/routing';

import { type ReviewCoachCoachFragment } from './__generated-gql-types__/ReviewCoach.generated';

interface ReviewCoachProps {
  coach: ReviewCoachCoachFragment;
}
export const ReviewCoach: FC<ReviewCoachProps> = ({ coach }) => {
  return (
    <Link
      className="flex w-full justify-between overflow-auto rounded-lg bg-leland-gray-hover p-0 hover:bg-leland-gray-stroke"
      href={getCoachProfileUrl(coach.slug)}
      id="review_coach--view_coach"
    >
      <div className="flex items-center gap-4 p-0">
        <ProfileImage
          className="size-14 rounded-none"
          objectFit="cover"
          {...coach.user}
        />
        <div>
          <span>Coached by</span>
          <span className="ml-1 font-medium underline">
            {coach.user.firstName}
          </span>
        </div>
      </div>
      <div className="flex items-center p-2">
        <IconArrowRight className="size-6" />
      </div>
    </Link>
  );
};
